var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default",null,{"record":_vm.record,"seed":_vm.seed,"loading":_vm.loading}),_vm._v("> ")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }